/** Permissions that show a confirmation dialog when enabled (turned on). */
export const PERMISSIONS_REQUIRING_CONFIRM_ON_ENABLE = new Set([
  "content:publish",
]);

export function requiresConfirmOnEnable(
  permission: string,
  checked: boolean,
  currentlyActive: boolean,
): boolean {
  return (
    checked &&
    !currentlyActive &&
    PERMISSIONS_REQUIRING_CONFIRM_ON_ENABLE.has(permission)
  );
}
